import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Modal, Form, Input, Button } from 'antd';
import {
  createPromptScreenAction,
  updatePromptScreenAction,
} from 'src/modules/SuperAdmin/store/actions/promptsv2.action';
import { scopeLabel } from './promptScreenConstants';

const { TextArea } = Input;

const PromptScreenModal = ({ open, onClose, mode, record, scope }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (open) {
      if (mode === 'edit' && record) {
        form.setFieldsValue({
          name: record.prompt_screen ?? '',
          description: record.description ?? '',
        });
      } else {
        form.resetFields();
      }
    }
  }, [open, mode, record, form]);

  const handleClose = () => {
    form.resetFields();
    setSubmitting(false);
    onClose();
  };

  const onFinish = async (values) => {
    const payload = {
      prompt_screen: values.name?.trim(),
      description: values.description?.trim() ?? '',
      scope,
    };
    setSubmitting(true);
    try {
      if (mode === 'create') {
        await dispatch(createPromptScreenAction(payload));
      } else if (record?.prompt_screens_id) {
        await dispatch(
          updatePromptScreenAction(record.prompt_screens_id, payload)
        );
      }
      handleClose();
    } catch {
      // Toasts handled in actions
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      title={mode === 'create' ? 'Add prompt screen' : 'Edit prompt screen'}
      open={open}
      onCancel={handleClose}
      footer={null}
      width={520}
      destroyOnClose
    >
      <p className="text-sm text-gray-500 -mt-1 mb-4">
        Scope:{' '}
        <span className="font-medium text-gray-700">{scopeLabel(scope)}</span>
      </p>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: 'Please enter a name' }]}
        >
          <Input placeholder="e.g. ambient_summary" />
        </Form.Item>
        <Form.Item name="description" label="Description">
          <TextArea rows={3} placeholder="Describe this prompt screen" />
        </Form.Item>
        <div className="flex justify-end gap-2 mt-4">
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="primary" htmlType="submit" loading={submitting}>
            {mode === 'create' ? 'Create' : 'Save'}
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default PromptScreenModal;
